<template>
  <div class="instruction-panel-container">
    <div class="panel-container">
      <div
          class="panel-content"
          :class="{
          hidden: instructionPanelWidth < minVisibleWidth,
          'with-padding': instructionPanelWidth > 400,
        }"
      >
        <div v-if="activeItem.toPath == 'contacts'" style="height: 100%">
          <InstructionPanelContacts :project="project"/>
        </div>
        <div v-else-if="activeItem.toPath == 'echanges'">
          <InstructionPanelEchanges :project="project"/>
        </div>
        <div v-else-if="activeItem.toPath == 'inscription-evaluation'">
          <InstructionPanelInscriptionEvaluation
              :project="project"
              :logged-user="loggedUser"
              :instruction-panel-width="instructionPanelWidth"
              @evaluation-saved="$emit('evaluation-saved')"
          />
        </div>
        <div v-else-if="activeItem.toPath == 'labellisation-qualification'">
          <InstructionPanelLabellisationQualification
              :project="project"
              :read-only="
              project.typeDossier === 'DOSSIER_INSCRIPTION' ||
              (project.statut !== 'EN_ATTENTE' &&
                project.statut !== 'INSTRUCTION_EN_COURS' &&
                project.statut !== 'INSTRUCTION_TERMINEE')
            "
          />
        </div>
        <div v-else-if="activeItem.toPath == 'labellisation-evaluation-finale'">
          <InstructionPanelLabellisationEvaluationFinale
              :project="project"
              :instruction-panel-width="instructionPanelWidth"
          />
        </div>
        <div v-else-if="activeItem.toPath == 'labellisation-mon-evaluation'">
          <InstructionPanelLabellisationMonEvaluation
              :project="project"
              :instruction-panel-width="instructionPanelWidth"
              :isSaving="isSaving"
              @save-evaluation="save"
          />
        </div>
      </div>
      <InstructionPanelMenu :project="project" @item-selected="newItemSelected"/>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue"
import {EvaluationDTO, ProjetAnnuelDTO, UtilisateurDTO} from "@/model/bean/GeneratedDTOs"
import {InfoReportingService} from "@/services/log/InfoReportingService"
import {ProjectService} from "@/services/rest/project/ProjectService"
import {NavbarItem} from "@/views/menus/MenuItems"
import InstructionPanelContacts from "./commons/InstructionPanelContacts.vue"
import InstructionPanelEchanges from "./commons/InstructionPanelEchanges.vue"
import InstructionPanelInscriptionEvaluation from "./commons/inscription/InstructionPanelInscriptionEvaluation.vue"
import InstructionPanelLabellisationQualification
  from "./commons/labellisation/InstructionPanelLabellisationQualification.vue"
import InstructionPanelLabellisationEvaluationFinale
  from "./commons/labellisation/InstructionPanelLabellisationEvaluationFinale.vue"
import InstructionPanelLabellisationMonEvaluation
  from "./commons/labellisation/InstructionPanelLabellisationMonEvaluation.vue"
import InstructionPanelMenu from "./InstructionPanelMenu.vue"

export default defineComponent({
  name: "InstructionPanel",
  components: {
    InstructionPanelMenu,
    InstructionPanelContacts,
    InstructionPanelEchanges,
    InstructionPanelLabellisationQualification,
    InstructionPanelLabellisationMonEvaluation,
    InstructionPanelLabellisationEvaluationFinale,
    InstructionPanelInscriptionEvaluation,
  },
  props: {
    project: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    instructionPanelWidth: {
      type: Number,
      default: 300,
    },
    minVisibleWidth: {
      type: Number,
      default: 100,
    },
    loggedUser: {
      type: Object as PropType<UtilisateurDTO>,
      default: () => null as UtilisateurDTO | null,
    },
  },

  emits: ["new-menu-selected", "evaluation-saved"],
  data() {
    return {
      inforReportingService: InfoReportingService.INSTANCE,
      projectService: ProjectService.INSTANCE,
      activeItem: new NavbarItem("", "", "", false),
      isSaving: false,
    }
  },
  methods: {
    newItemSelected(newSelectedItem: NavbarItem): void {
      this.activeItem = newSelectedItem
      this.$emit("new-menu-selected")
    },

    async save(evaluation: EvaluationDTO): Promise<void> {
      //save evaluation
      this.isSaving = true
      await this.projectService.updateEvaluation(this.project, evaluation)

      //replace evaluation in projetAnnuel
      this.$emit("evaluation-saved")
      this.isSaving = false
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.panel-container {
  display: flex;
  justify-content: flex-end;
  overflow-y: hidden;

  .panel-content {
    width: 100%;
    padding: 10px;
    overflow-y: hidden;

    &.with-padding {
      padding-left: 25px;
      padding-right: 25px;
    }

    &.hidden {
      display: none;
    }

    .instruction-panel-entry {
      .h2 {
        font-family: $font-family-title;
        text-align: center;
        font-size: 20px;
        padding-top: 5px;
      }

      max-height: calc(100vh - #{$header-height} - 40px);
      height: calc(100vh - #{$header-height} - 40px);
      overflow-x: hidden;
      overflow-y: auto !important;
    }
  }
}
</style>
